import React from 'react'
import Slider from "react-slick";

export default function HaldiLogoslider() {
    const settings = {
    dots: false,
    arrows: false,
    slidesToShow: 6,
    infinite: true,
    autoplay: false,
    slidesToScroll: 1,
    pauseOnHover: false,
    cssEase: "linear",
    autoplaySpeed: 0,
    speed: 6000,
    draggable: false,
    swipe: false,
    responsive: [
        {
            breakpoint: 991,
            settings: { slidesToShow: 4, autoplay: true, },
            },
        {
            breakpoint: 767,
            settings: { slidesToShow: 3, autoplay: true,},
        },
        {
            breakpoint: 599,
            settings: { slidesToShow: 2, autoplay: true,},
        },
    ],
    };

  return (
    <>
    <section className="haldipage-feature">
        <div className="container">
            <div className="row">

                <div className="col-lg-12">
                    <p className='heading'>Sonam Label Proudly Featured In</p>

                    <Slider {...settings}>
                        <div className='feature-logobox'>
                            <img src="/image/featured-logo-1.webp" className="img-responsive" alt="Featured" loading="lazy"/>
                        </div>
                        <div className='feature-logobox'>
                            <img src="/image/featured-logo-2.webp" className="img-responsive" alt="Featured" loading="lazy"/>
                        </div>
                        <div className='feature-logobox'>
                            <img src="/image/featured-logo-3.webp" className="img-responsive" alt="Featured" loading="lazy"/>
                        </div>
                        <div className='feature-logobox feature-other'>
                            <img src="/image/featured-logo-4.webp" className="img-responsive" alt="Featured" loading="lazy"/>
                        </div>
                        <div className='feature-logobox'>
                            <img src="/image/featured-logo-5.webp" className="img-responsive" alt="Featured" loading="lazy"/>
                        </div>
                        <div className='feature-logobox'>
                            <img src="/image/featured-logo-6.webp" className="img-responsive" alt="Featured" loading="lazy"/>
                        </div>
                    </Slider>
                </div>

            </div>
        </div>
    </section>
    </>
  )
}
